import { NextRouter } from 'next/router';
import { match } from 'path-to-regexp';

import { parse as parseQuery } from 'querystring';

import { routes } from '@routes';

export const createLinkClickHandler = (
  linkElement: HTMLAnchorElement,
  router: NextRouter,
) => {
  const href = linkElement.getAttribute('href') as string; // just for ts, it would not pass the filter if it had no 'href' attr
  const pathToPush =
    href[0] === '/'
      ? href
      : href.replace(
          new RegExp(
            `(http(s)?://)?(${document.location.hostname}|(www.)?reas.cz)(:\\d{4})?/?`,
          ),
          '/',
        );

  return async (e: MouseEvent) => {
    if (e.ctrlKey) {
      window.open(`${document.location.origin}${pathToPush}`, '_blank');
      return e.preventDefault();
    }

    for (const [pathRegexString, pathname] of Object.values(routes)) {
      const [href, query] = pathToPush.split('?');
      const parsedQueryParams = parseQuery(query);

      const matched = match<Record<string, any>>(pathRegexString)(href);

      if (matched) {
        e.preventDefault();
        await router.push(
          {
            pathname,
            href,
            query: { ...parsedQueryParams, ...matched.params },
          },
          pathToPush,
        );
        return window.scrollTo(0, 0);
      }
    }
  };
};
